/* Diwali 2026: the Diwali page's sparkler on every page (user, 25 Oct: "the
   sparkle on diwali page has to be on the entire site"). Same engine and feel as
   assets/diwali-registration.js, which keeps its own on the Diwali page:
   - desktop: the mouse is a sparkler, anywhere on the page;
   - phones: a finger drags one, with a streak behind it and a short afterglow
     where it lifts, sparks 1.5x bigger and 1.8x longer (Punit, 20 Oct), as the
     Diwali page's defaults.
   No dial ring: that one circles the watch in the Diwali page's photo.
   The canvas is fixed over the window just under the site header; its CSS and
   the on/off switch (Theme settings > Diwali sparkle) are in
   snippets/diwali-sparkle.liquid. */
(function () {
  if (window.__dwSiteSparkle) return;
  window.__dwSiteSparkle = true;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var canvas = document.createElement('canvas');
  if (!canvas.getContext) return;
  canvas.className = 'dw-site-sparks';
  canvas.setAttribute('aria-hidden', 'true');
  document.body.appendChild(canvas);
  document.documentElement.classList.add('dw-sparkler');

  var ctx = canvas.getContext('2d');
  var desktopQuery = window.matchMedia ? window.matchMedia('(min-width: 990px)') : { matches: true };
  var DENSITY = 6, PHONE_SIZE = 1.5, PHONE_LIFE = 1.8;
  var W = 0, H = 0, raf = 0;
  var E = { sparks: [], tip: null, touch: false, newStroke: false, linger: null, trail: [] };

  // Phones get bigger, longer sparks; desktop keeps the design's numbers.
  function boost() { return desktopQuery.matches ? null : { size: PHONE_SIZE, life: PHONE_LIFE }; }

  function resize() {
    var dpr = Math.min(2, window.devicePixelRatio || 1);
    W = canvas.clientWidth; H = canvas.clientHeight;
    canvas.width = Math.round(W * dpr); canvas.height = Math.round(H * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }

  // w scales the spark's line width, l the life of the sparks it crackles into.
  function emit(x, y, sp, life, w, l) {
    var a = Math.random() * 6.283;
    E.sparks.push({ x: x, y: y, vx: Math.cos(a) * sp, vy: Math.sin(a) * sp - 0.4, life: life, max: life, split: Math.random() < 0.18, w: w || 1, l: l || 1 });
  }

  // A finger lifted: on phones the sparkler burns on where it was for a moment.
  function release() {
    var b = boost();
    if (E.tip && E.touch && b) {
      var span = 350 * b.life;
      E.linger = { x: E.tip.x, y: E.tip.y, until: Date.now() + span, span: span };
    }
    E.tip = null;
    E.touch = false;
  }

  function glow(x, y, R, alpha) {
    var g = ctx.createRadialGradient(x, y, 0, x, y, R);
    g.addColorStop(0, 'rgba(255,250,230,1)');
    g.addColorStop(0.25, 'rgba(255,200,90,.85)');
    g.addColorStop(1, 'rgba(255,150,40,0)');
    ctx.globalAlpha = alpha;
    ctx.fillStyle = g; ctx.beginPath(); ctx.arc(x, y, R, 0, 6.29); ctx.fill();
    ctx.globalAlpha = 1;
  }

  // Draws one frame; returns true while there is anything left to animate.
  function frame() {
    ctx.clearRect(0, 0, W, H);
    var now = Date.now();
    var b = boost();
    var size = b ? b.size : 1, longer = b ? b.life : 1;
    var tip = E.tip, power = 1;
    var source = tip ? (E.touch ? 'touch' : 'mouse') : null;
    if (!tip && E.linger) {
      var left = (E.linger.until - now) / E.linger.span;
      if (left > 0) { tip = E.linger; power = left; source = 'linger'; }
      else E.linger = null;
    }
    // Long-exposure streak behind a finger on phones, fading over about 1.5 s.
    if (source === 'touch' && b) {
      var last = E.trail[E.trail.length - 1];
      E.trail.push({ x: tip.x, y: tip.y, t: 1, fade: 0.018 / longer, w: size, brk: !last || E.newStroke });
      E.newStroke = false;
    }
    E.trail = E.trail.filter(function (p) { return (p.t -= p.fade) > 0; });
    ctx.lineCap = 'round';
    for (var i = 1; i < E.trail.length; i++) {
      var p0 = E.trail[i - 1], p1 = E.trail[i];
      if (p1.brk) continue;
      ctx.strokeStyle = 'rgba(255,205,120,' + p1.t * 0.55 + ')';
      ctx.lineWidth = 2.2 * p1.t * p1.w;
      ctx.beginPath(); ctx.moveTo(p0.x, p0.y); ctx.lineTo(p1.x, p1.y); ctx.stroke();
    }
    if (tip) {
      var n = Math.round((DENSITY + Math.random()) * power);
      for (var k = 0; k < n; k++) emit(tip.x, tip.y, (1.5 + Math.random() * 3.5) * size, (22 + Math.random() * 22) * longer, size, longer);
      glow(tip.x, tip.y, 22 * size, power);
    }
    E.sparks = E.sparks.filter(function (p) {
      p.px = p.x; p.py = p.y; p.vy += 0.06; p.vx *= 0.985; p.vy *= 0.985; p.x += p.vx; p.y += p.vy; p.life--;
      var t = p.life / p.max;
      if (t <= 0) return false;
      ctx.strokeStyle = t > 0.6 ? 'rgba(255,244,210,' + t + ')' : 'rgba(235,' + ((120 + 90 * t) | 0) + ',40,' + t + ')';
      ctx.lineWidth = (1.4 * t + 0.3) * p.w;
      ctx.beginPath(); ctx.moveTo(p.px - p.vx * 1.5, p.py - p.vy * 1.5); ctx.lineTo(p.x, p.y); ctx.stroke();
      if (p.split && t < 0.55) {
        p.split = false;
        for (var m = 0; m < 3; m++) emit(p.x, p.y, (1 + Math.random() * 1.5) * p.w, (12 + Math.random() * 10) * p.l, p.w, p.l);
      }
      return true;
    });
    return !!(tip || E.linger || E.sparks.length || E.trail.length);
  }

  function loop() {
    raf = 0;
    if (frame()) raf = requestAnimationFrame(loop);
  }
  function kick() { if (!raf) raf = requestAnimationFrame(loop); }

  resize();
  if ('ResizeObserver' in window) new ResizeObserver(function () { resize(); kick(); }).observe(canvas);
  else window.addEventListener('resize', function () { resize(); kick(); });
  if (desktopQuery.addEventListener) desktopQuery.addEventListener('change', kick);

  // Real mice only: phones also send a mousemove after each tap, which would
  // leave the sparkler burning at the last tap. Fingers use the touch events.
  document.addEventListener('pointermove', function (e) {
    if (e.pointerType !== 'mouse') return;
    E.tip = { x: e.clientX, y: e.clientY };
    E.touch = false;
    kick();
  }, { passive: true });
  // relatedTarget is null only when the pointer leaves the window.
  document.addEventListener('mouseout', function (e) { if (!e.relatedTarget && !E.touch) E.tip = null; });
  function onTouch(e) {
    var t = e.touches && e.touches[0];
    if (!t) return;
    if (!E.touch) E.newStroke = true;
    E.touch = true;
    E.linger = null;
    E.tip = { x: t.clientX, y: t.clientY };
    kick();
  }
  function onTouchEnd() { release(); kick(); }
  document.addEventListener('touchstart', onTouch, { passive: true });
  document.addEventListener('touchmove', onTouch, { passive: true });
  document.addEventListener('touchend', onTouchEnd, { passive: true });
  document.addEventListener('touchcancel', onTouchEnd, { passive: true });
})();
